import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-redirect',
  template: '' // oppure '<p>Redirecting...</p>' se vuoi un messaggio temporaneo
})
export class HelpRedirectComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigateByUrl('d/SUPPORT_TICKETS/f', { skipLocationChange: true });
  }
}
